var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M-2.7 510.07C-2.7 510.27 -2.85 510.43 -3.05 510.43C-3.25 510.43 -3.4 510.27 -3.4 510.07C-3.4 509.88 -3.25 509.72 -3.05 509.72C-2.85 509.72 -2.7 509.88 -2.7 510.07Z",
    id: "a2tGslbiHt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.73 50C89.73 71.12 71.45 88.27 48.94 88.27C26.44 88.27 8.16 71.12 8.16 50C8.16 28.88 26.44 11.73 48.94 11.73C71.45 11.73 89.73 28.88 89.73 50Z",
    id: "b1VVGTp0ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.19 48.69L69.13 61.63L61.89 68.88L48.94 55.94L36 68.88L28.75 61.63L41.7 48.69L28.75 35.75L36 28.5L48.94 41.44L61.89 28.5L69.13 35.75L56.19 48.69Z",
    id: "a35quVPDH0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2tGslbiHt",
    opacity: 1,
    fill: "#71c8ad",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1VVGTp0ba",
    opacity: 1,
    fill: "transparent",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1VVGTp0ba",
    opacity: 1,
    fillOpacity: 0,
    className: "stroke0",
    strokeWidth: 5,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M56.19 48.69L69.13 61.63L61.89 68.88L48.94 55.94L36 68.88L28.75 61.63L41.7 48.69L28.75 35.75L36 28.5L48.94 41.44L61.89 28.5L69.13 35.75L56.19 48.69Z",
    id: "a35quVPDH0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.d7264dadb60faaf3befa225c8135b305.svg";
export { ForwardRef as ReactComponent };